import createConnectPrefetch from './prefetch';
import connectPending from './pending';
import { compose } from 'redux';
import { connectState, createConnectActions, createConnectSelectors } from './connect';
/**
 * Creates a list of decorators
 *
 * @param  {Object} [actions = {}] - application action creators
 * @param  {Object} [selectors = {}] - application selectors
 * @return {Object} - connect wrappers
 */

export default function createConnectWrappers(_ref) {
  var _ref$actions = _ref.actions,
    actions = _ref$actions === void 0 ? {} : _ref$actions,
    _ref$selectors = _ref.selectors,
    selectors = _ref$selectors === void 0 ? {} : _ref$selectors;
  var connectSelectors = createConnectSelectors(selectors);
  var connectActions = createConnectActions(actions);
  var connectPrefetch = createConnectPrefetch(actions);
  var connect = function connect(options) {
    return function (Component) {
      return compose(connectState(options.state), connectSelectors(options.selectors), connectActions(options.actions), connectPrefetch(options.prefetch), connectPending(options.pending))(Component);
    };
  };
  return {
    connect: connect,
    connectState: connectState,
    connectSelectors: connectSelectors,
    connectActions: connectActions,
    connectPrefetch: connectPrefetch,
    connectPending: connectPending
  };
}
import _serverPrefetch from './prefetch/serverPrefetch';
export { _serverPrefetch as serverPrefetch };
export { createSelector } from 'reselect';
import _pendingActionsMiddleware from './pending/middleware';
export { _pendingActionsMiddleware as pendingActionsMiddleware };
import _pendingActionsReducer from './pending/reducer';
export { _pendingActionsReducer as pendingActionsReducer };
import _isPendingAction from './pending/isPending';
export { _isPendingAction as isPendingAction };